import { TW_PAGES } from "./tunbridgeWells";
import { AREA_PAGES } from "./areas";
import { INDUSTRY_PAGES } from "./industries";

export const LANDING_PAGES = { ...TW_PAGES, ...AREA_PAGES, ...INDUSTRY_PAGES };

export const LOCATION_LINKS = Object.entries({ ...TW_PAGES, ...AREA_PAGES }).map(([slug, p]) => [`/${slug}`, p.navTitle]);
export const INDUSTRY_LINKS = Object.entries(INDUSTRY_PAGES).map(([slug, p]) => [`/${slug}`, p.navTitle]);

// Old URLs kept as redirects after consolidation (Nov 2026).
export const LANDING_REDIRECTS = { "/seo-tunbridge-wells": "/seo-consultant-tunbridge-wells", "/ppc-tunbridge-wells": "/ppc-consultant-tunbridge-wells" };
